import { useMutation } from '@apollo/client';
import MESSAGE_TARGETS from '../../../signalR/constants/signalRMessageTargets';
import { useNonBlockingFileUpload } from '@shared/hooks/useNonBlockingFileUpload';
import ADD_OBSERVATION_REPORT_DOCUMENT from '../queries/addObservationReportDocumentMutation';
import { ObservationReportDocumentsMapper } from '../mappers/ObservationReportDocumentsMapper';
import { useNavigate } from 'react-router';
import { useObservationReportFileDownload } from '../../shared/hooks/useObservationReportFileDownload';

const SAVE_OBSERVATION_REPORT_SUCCESS_MESSAGE =
  'Observation report has been uploaded successfully.';
const UPLOAD_FILE_ERROR_MESSAGE = 'Unable to upload file.';
const SAVING_OBSERVATION_REPORT_MESSAGE = 'Uploading observation report...';

export const useManageObservationReportDocuments = (eventId, observedUserId) => {
  const navigate = useNavigate();

  const [addObservationReportMutation, { error: addObservationReportError }] = useMutation(
    ADD_OBSERVATION_REPORT_DOCUMENT
  );

  const { handleFileDownload } = useObservationReportFileDownload();

  const { uploadFile, uploadFileLoading } = useNonBlockingFileUpload({
    loadingMessage: SAVING_OBSERVATION_REPORT_MESSAGE,
    successMessage: SAVE_OBSERVATION_REPORT_SUCCESS_MESSAGE,
    errorMessage: UPLOAD_FILE_ERROR_MESSAGE,
    signalRMessageTarget: MESSAGE_TARGETS.OBSERVATION_REPORT_FILE_VALIDATION_NOTIFICATION,
    onSuccess: () => navigate('/')
  });

  const handleAddObservationReport = async observationReportData => {
    const { file } = observationReportData;

    const fileUrlProvider = async () => {
      const { data, errors } = await addObservationReportMutation({
        variables: {
          observationReport: ObservationReportDocumentsMapper.toApolloInput(observationReportData)
        }
      });

      if (!data?.addObservationReport || errors) {
        throw new Error('Failed to add observation report record.');
      }

      return data.addObservationReport;
    };

    await uploadFile(file, fileUrlProvider);
  };

  const handleDownloadObservationReportFile = () => handleFileDownload(eventId, observedUserId);

  return {
    handleAddObservationReport,
    handleDownloadObservationReportFile,
    addObservationReportError,
    uploadFileLoading
  };
};
